type Fbq = (...args: unknown[]) => void

/**
 * Fire the Meta Pixel "Lead" standard event on a CONFIRMED form submission
 * (i.e. after /api/submit-lead returns result === "success"), not on page view
 * or form open. No-ops safely when the pixel isn't present — local dev, the
 * META_PIXEL_ID build var being unset, or fbq blocked by an ad blocker.
 *
 * Pass a `source` to segment leads in Meta (Events Manager > Lead > by
 * content_name): "propertyManager", "owner", etc.
 */
export function trackLead(source?: string): void {
  if (typeof window === "undefined") return
  const fbq = (window as unknown as { fbq?: Fbq }).fbq
  if (typeof fbq !== "function") return
  fbq("track", "Lead", source ? { content_name: source } : undefined)
}
